import { NFTResult } from '@jdiyield/interfaces'
import { api } from '@jdiyield/utils'

export async function getNFTOpenSea(account: string): Promise<NFTResult[]> {
  try {
    const { data } = await api.get(`https://api.opensea.io/api/v1/assets?owner=${account}&limit=50`)
    return data?.assets?.map(
      ({ image_url, token_id, permalink, name, creator, animation_url }) =>
        ({
          creator: creator?.user?.username,
          creatorLink: 'https://opensea.io/' + creator?.user?.username,
          name,
          tokenID: token_id,
          asset_url: animation_url,
          thumbnail_url: image_url,
          link: permalink
        } as NFTResult)
    )
  } catch (error) {
    console.log(error)
    return []
  }
}
